import { render, staticRenderFns } from "./AccountExpiredAlert.vue?vue&type=template&id=06e3fa82&"
import script from "./AccountExpiredAlert.vue?vue&type=script&lang=js&"
export * from "./AccountExpiredAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports